//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { MediaFilterParamKey } from '@apis/content-library/contentLibraryApiModel';

export interface FilterSection<T extends FilterValue> {
  options: FilterOption<T>[];
  paramKey: MediaFilterParamKey;
}

export interface FilterOption<T extends FilterValue> {
  label: string;
  isSelected: boolean;
  value: T;
  trackingId?: string;
}

export interface NestedFilterOption<T extends FilterValue>
  extends FilterOption<T> {
  subOptions?: FilterOption<T>[];
  isEnabled: boolean;
}

export type FilterValue = string | number | boolean;

export const FilterSectionTitle: Record<MediaFilterParamKey, string> = {
  campaignSubTypes: '',
  campaignTypes: 'Campaigns',
  createdAfter: '',
  dateRange: 'Date Range',
  distribution: 'Distributed to',
  // PD-301894: Remove excludeTargetedRetailerCampaigns and excludeNonTargetedRetailerCampaigns
  excludeNonTargetedRetailerCampaignItems: '',
  excludeTargetedRetailerCampaignItems: '',
  filter: '',
  hasLabels: 'Labels',
  hasProducts: 'Product Tags',
  igHashtags: 'Hashtags',
  igUsernames: 'Usernames',
  includeMissingMedia: '',
  instagramMentionedUsernames: '',
  isDistributed: 'Distribution',
  isRepresentativeItem: '',
  isScheduled: '',
  itemId: '',
  itemTypes: '',
  labels: 'Labels',
  mediaItemTypes: 'Media Type',
  networks: 'Platforms',
  orientation: 'Orientation',
  platforms: 'Platforms',
  productIds: 'Product Tagged',
  rejectionType: 'Moderation Rejection Type',
  rightsStatuses: 'Rights',
  searchText: '',
  semanticTags: 'Visual Tags',
  spamFiltering: 'Spam Filtering',
  userIds: '',
};
